import { config } from "config";

export const environment = {
  production: false,
  apiURL: config.devApiUrl,
  syncFusionLicense: config.syncFusionLicense,
  company: 'elevated',
  iconLogo: 'assets/images/logo/logo_big.png',
  coverLogo: 'assets/images/logo/logo_cover.svg',
  theme: 'theme-default',
};
